exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".overlay {\n  position: absolute;\n  z-index: 10000;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  background: #ededed; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/Thomas/Projekte/palettes/src/app/shared/components/loading-overlay/loading-overlay.component.scss
// module id = ../../../../../src/app/shared/components/loading-overlay/loading-overlay.component.scss
// module chunks = main